import { ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

const fieldLabelBox: ThemeUICSSObject = {
  display: 'flex',
  gap: spacing(1),

  /* PREPEND HERE */
};

export default fieldLabelBox;
